export const projectData = [
	{
		name: 'refactor-syscall-creation-script',
		date: '2024',
		link: 'https://wiki.freebsd.org/SummerOfCode2024Projects/RefactorSyscallCreationScript',
		desc: `
This project has a wiki page, and it's so much more detailed than I'll be 
going into here. Please refer to it. The short description is that 
I refactored <code>/src/sys/tools/makesyscalls.lua</code> into an OOP 
library. Achieving the following outcomes: the new library is easier for new 
contributors to understand, it provides a solid foundation for future system 
call creation scripts, and it's modularized to allow dynamic generation of 
FreeBSD system files. The other outcomes are that FreeBSD has a great 
community, so be a part of it!
`
	},
	{
	name: 'agge-plugins',
	date: '2024',
	link: 'https://www.github.com/agge3/agge-plugins',
	desc: `
Java extension library to automate the popular MMORPG and open source 
client, Old School RuneScape and RuneLite. Fork of some pre-existing work in
the area, but designed to do what I want to accomplish and not what the
existing work wants to accomplish. This involves expanding the API to do 
more robust things and utilizing design patterns to accomplish more with 
less. Also, to have something that fits my needs. So it's very much for me, 
but it's a notable amount of work and design.
`,
	},
	{
		name: 'berry-picking-simulator',
		date: '2024',
		link: 'https://www.github.com/agge3/berry-picking-simulator',
		desc: `
	A cute little game to crash course on GNU Guile and also implement a game
	with a recursive game loop. Everything's done recursively where it could be,
	because that's the fun in this project. Lisp is great!
`
	},
	{
		name: 'occ-accessibility-tour',
		date: '2024',
		link: 'https://www.github.com/agge3/occ-accessibility-tour',
		desc: `
	Fork of untitled game. Re-uses all of the engine code, but produces an 
	actually presentable and playable game. The game is an interactive tour of
	Orange Coast College, with great creative liberty taken on the presentation
	of the college. The most notable thing, however, is that it can played 
	exclusively by voice input! The API for the voice input is Mozilla's 
	DeepSpeech C library, packaged and tuned in a way that makes sense for video 
	game controls. It's designed to be reusable, to support more diverse and
	accessible ways of interacting with video games.
`
	},
	{
		name: 'untitled-game',
		date: '2024',
		link: 'https://www.github.com/agge3/untitled-game',
		desc: `
    An untitled game using SFML. Follows
    <a href="https://www.packtpub.com/product/sfml-game-development/9781849696845"
        class="permalink">
    SFML Game Development</a>.
    Instead of making a vertically scrolling airplane shooter though, I've made
    a top-down open world RPG. Greatly expanding the currently empty, but vast,
	project scope. Only supported on Linux. Windows target from Linux was a 
	thing at one point, with that still being included in the build system. 
	That's pending a better workflow, and my desire (which I don't have much) to
	do it.
`
	},
	{
		name: 'breakout',
		date: '2024',
		link: 'https://www.github.com/agge3/breakout',
		desc: `
This project has a wiki page, and it's so much more detailed than I'll be 
going into here. Please refer to it. The short description is that 
I refactored <code>/src/sys/tools/makesyscalls.lua</code> into an OOP 
library. Achieving the following outcomes: the new library is easier for new 
contributors to understand, it provides a solid foundation for future system 
call creation scripts, and it's modularized to allow dynamic generation of 
FreeBSD system files. The other outcomes are that FreeBSD has a great 
community, so be a part of it!
`
	},
	{
		name: 'lockscreen',
		date: '2024',
		link: 'https://www.github.com/agge3/lockscreen"',
		desc: `
    <b>Work in progress.</b> A simple lock screen for Wayland, elogind, and
    Hyprland that uses the D-Bus low-level C API to listen for the "Lock"
    message from org.freedesktop.login1 (e.g., <code>loginctl</code>).
    <code>lockscreen</code> then uses the Wayland protocol to interact with the
    Wayland display and lock the session.
`
	},
];

export const about1 = `
Junior CompSci student. UNIX enthusiast. Focus on low-level, or whatever suits
the task.
`

export const aboutHtml = `
Undergraduate pursuing Bachelor of Computer Science at San Francisco State University, graduating Spring 2026.
<br><br>
Software Engineer specialized in low-level (C/C++), back-end (C++, Java), and system administration (Bash, Lua, Perl). Daily drive Gentoo Linux desktop and FreeBSD server. Have experience from the bottom of the stack to the top, ranging from kernel to DevOps(deployment and cloud infrastructure). It’s easier to go up then it is to go down (I have experience with many things..!). I also have a tendency of eagerly learning anything I don’t know :)
Just ask me a question~
<br><br>
Open source enthusiast with contributions to FreeBSD for Google Summer of Code 2024. Most software I use is open source, and I give back when I can!
<br><br>
Give me a shell and an editor and I’ll start making things, though I prefer Zsh and Neovim.
`
